import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import { Navigate } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { useReportRootPath } from "../../hooks";
import TamperingIssues from "../issuesDiff/threatHunting/TamperingIssues";
import { useVersionDiffContext } from "./VersionDiff";
const ThreatHuntingTab = () => {
    const { issues, hasIssues } = useVersionDiffContext();
    const reportRootPath = useReportRootPath();
    if (!hasIssues)
        return (React.createElement(Navigate, { to: `${reportRootPath}/${REPORT_PAGES_ROUTES.VERSION_DIFF}/${REPORT_PAGES_ROUTES.VERSION_DIFF_ISSUE_CHANGES}`, replace: true }));
    return (React.createElement(ErrorBoundary, { key: "tampering-issues" },
        React.createElement(TamperingIssues, { issues: issues, idPrefix: "diff-issues" })));
};
export default ThreatHuntingTab;
//# sourceMappingURL=ThreatHuntingTab.js.map